import React from 'react';

import SimpleMessagePage from 'components/SimpleMessagePage';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';

const UnifiedFraudAlertOfac: React.FC = () => {
  const tMd = useMarkdownTranslate();
  return (
    <SimpleMessagePage
      headerTitle={'unified.placeOrder.error.fraudAlertOfac.title'}
      message={tMd('unified.placeOrder.error.fraudAlertOfac.message')}
    ></SimpleMessagePage>
  );
};

export default UnifiedFraudAlertOfac;
